<template>
  <div>
    <el-menu class="el-menu leftMenu" :default-active="tacit" active-text-color="" text-color="#6a6a6a"
      :default-openeds="openeds" @select="handleSelect">
      <el-submenu index="1-2">
        <template slot="title">
          <span :default-active="tacit">标签统计</span>
        </template>
        <el-menu-item index="/Reference_statistics">参考图标签</el-menu-item>
        <el-menu-item index="/Mode_statistics">模型人标签</el-menu-item>
        <el-menu-item index="/traffic_statistics">模型交通标签</el-menu-item>
        <el-menu-item index="/plant_statistics">模型植物标签</el-menu-item>
        <el-menu-item index="/Residence_statistics">模型家居标签</el-menu-item>
        <el-menu-item index="/scene_statistics">模型场景标签</el-menu-item>
        <el-menu-item index="/Pspeople_statistics">PS人标签</el-menu-item>
        <el-menu-item index="/PSplant_statistics">PS植物标签</el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
export default {
  data() {
    return {
      Selected3: "",
      tacit: "",
      openeds: ["1"],
    };
  },
  computed: {
    Selected: {
      get() {
        return this.$store.getters.process;
      },
      set() { },
    },
  },
  created() {
    //   this.tacit =this.$route.path
    if (sessionStorage.getItem("Selected3")) {
      this.tacit = sessionStorage.getItem("Selected3");
    } else {
      this.tacit = "/Reference_statistics";
    }
    if (sessionStorage.getItem("Selected3")) {
      this.Selected = sessionStorage.getItem("Selected3");
    }
  },
  destroyed() {
    sessionStorage.removeItem('Selected3')
    sessionStorage.removeItem('Selected')
  },

  mounted() { },
  methods: {
    handleSelect(e) {
      if (e == 1 || e == 2 || e == 3 || e == 4 || e == 5) {
        this.$store.dispatch("setPSprocess", e);
        sessionStorage.setItem("Selected", e);
        this.Selected = e;
        if (!sessionStorage.getItem("Selected3")) {
          this.Selected3 = "/Reference_statistics";
        }
        return;
      }
      if (this.Selected3 == e) {
        return;
      }
      this.Selected = 2;
      this.$store.dispatch("setPSprocess", 2);
      this.Selected3 = `${e}`;
      sessionStorage.setItem("Selected3", e);
      this.$router.push(e);
    },
  },
};
</script>
<style scoped>
.el-aside .el-menu {
  width: 100%;
  min-height: 100%;
  border: none;
  margin: 0 2%;
  font-weight: normal;
}

.el-dropdown-menu__item,
.el-menu-item {
  font-family: Avenir, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji", sans-serif;
  font-size: 12px;
  height: 40px !important;
  line-height: 40px !important;
  width: 95%;
  margin-top: 1px;
  padding: 0 40px;
}

.el-menu-item:focus,
.el-menu-item:hover {
  border-radius: 8px;
  background: #fff !important;
}

.el-menu-demo .el-menu-item:hover {
  border-radius: 0px;
}

.selected {
  background-color: rgba(233, 244, 254, 1);
  color: #000 !important;
  border-radius: 8px;
}

.el-menu-demo .el-menu-item {
  border-radius: 0;
}

.el-aside .is-active {
  border-radius: 8px;
  background-color:#F0F0F0 ;
  color: #373535;
}


.menu_scroll {
  overflow-x: hidden;
}

/deep/ .el-submenu.is-active .el-submenu__title {
  border-bottom-color: #fff;
}

>>>.el-submenu__title {
  font-family: Avenir, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji", sans-serif;
  font-size: 12px !important;
  height: 40px;
  line-height: 40px;
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/Label_quantity/components/LableMenu.vue